import { ClassificationLevel } from '@sonar-software/sonar-core';
import { ClassificationTag } from './ClassificationTag';
import { enumStringKeys } from '@sonar-software/sonar-ts-lib';
import React from 'react';

import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { FilterOption, OptionFilter } from '@periscopes/general/filters';

const optionRender = (value?: unknown) => (value ?
	<ClassificationTag classification={ value as ClassificationLevel } /> : undefined);

const options: Array<FilterOption> = enumStringKeys(ClassificationLevel).map((label) => ({
	label,
	value: ClassificationLevel[ label ]
}));

export interface ClassificationBulkSelectorProps {
	boxless?: boolean;
	getPopupContainer?: (trigger: HTMLElement) => HTMLElement;
	isSpreadsheet?: boolean;
	onChange: (value: ClassificationLevel) => void;
	value?: ClassificationLevel;
}

export const ClassificationBulkSelector: React.FC<ClassificationBulkSelectorProps> = ({ onChange, value }) =>
	<OptionFilter
		labelRender={ (option) => optionRender(option.value) }
		onChange={ onChange }
		optionRender={ (option) => optionRender(option.value) }
		options={ options }
		placeholder={ COPY_GENERIC.SELECT(COPY_SPECIFIC.CLASSIFICATION) }
		value={ value } />;
